import { useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowRight } from "lucide-react";
import { FAQS } from "@/data/catalog";

const CATS = ["All", ...Array.from(new Set(FAQS.map((f) => f.cat)))];

export default function FAQ() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? FAQS : FAQS.filter((f) => f.cat === cat);

  return (
    <div data-testid="faq-page">
      <PageHeader overline="FAQ" title="Answers to common questions." subtitle="Everything you need to know about ordering, customization, shipping and payments with ElitzPacks." />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10 grid lg:grid-cols-[240px_1fr] gap-10">
        <div className="flex lg:flex-col gap-2 overflow-x-auto no-scrollbar">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`faq-cat-${c.toLowerCase().replace(/\s/g, "-")}`} className={`whitespace-nowrap text-left rounded-full lg:rounded-xl px-5 py-2.5 text-sm font-medium border transition-colors ${cat === c ? "bg-navy text-white border-navy" : "border-border hover:bg-secondary"}`}>{c}</button>
          ))}
        </div>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {list.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-lg">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <div className="rounded-4xl bg-navy text-white p-10 lg:p-16 text-center">
          <h2 className="font-heading text-3xl lg:text-4xl font-extrabold">Still have questions?</h2>
          <p className="mt-3 text-white/60 max-w-md mx-auto">Our packaging specialists are ready to help you find the perfect solution.</p>
          <Link to="/contact" className="mt-7 inline-flex items-center gap-2 rounded-full bg-white text-navy px-7 py-3.5 font-semibold hover:bg-emerald hover:text-white transition-colors">Contact Us <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
